import { fastclick, shim } from './configs';
import injectScripts from './inject-scripts';

// 性能监控
const initPerformanceMonitoring = () => {
  if (window.performance && window.performance.mark) {
    window.performance.mark('init-start');
  }
};

// 异步初始化
const asyncInitialize = async () => {
  try {
    // 初始化基础功能
    if (fastclick.enable) {
      fastclick.run();
    }

    if (shim.enable) {
      shim.run();
    }

    // 异步注入脚本
    await injectScripts();

    // 记录性能指标
    if (window.performance && window.performance.mark) {
      window.performance.mark('init-end');
      window.performance.measure('init-duration', 'init-start', 'init-end');
    }
  } catch (error) {
    console.error('初始化失败:', error);
  }
};

const initialize = () => {
  initPerformanceMonitoring();
  asyncInitialize();
};

export default initialize;
